module.exports = __webpack_public_path__ + "be91037dae8f336ccb5e4d46066a54db.svg";